import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const getMonthlyCheckout = async (data: any) => {
	const URL = `${API_URL}GetMonthlyReport`;
	// const response = await axios.post(`${API_URL}GetMonthlyReport`, data);
	// return response.data;
	const requestData = {
		getMonthlyCheckoutToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const getMonthlyCheckoutDetails = async (data: any) => {
	const URL = `${API_URL}GetMonthlyReportDetails`;
	// const response = await axios.post(`${API_URL}GetMonthlyReportDetails`, data);
	// return response.data;
	const requestData = {
		getMonthlyCheckoutDetailsToken: data,
	};
	return makeApiCall(URL, requestData);
};
